namespace JupitersChoice {
    export class PaylineDisplay extends Sapphire.PaylineDisplay {

        @inject('StateModel') _stateModel: Sapphire.StateModel;

        protected _sprite2Mask: PIXI.Sprite;

        constructor() {
            super();
        }

        construct(data: any) {
            super.construct(data);
        }

        setOrientation(orientation: string): void {
            this.x = this._data.position[orientation].x;
            this.y = this._data.position[orientation].y;

            this.scale.x = this._data.scale[orientation].x;
            this.scale.y = this._data.scale[orientation].y;

            if (this._stateModel.currentSubgame === 'FreeGame' && orientation === 'portrait') {
                this.y += 193;
            }
        }

        set sprite2Mask(newSprite: PIXI.Sprite){
            this._sprite2Mask = newSprite;
        }

        show(
            payline: Array<Sapphire.PaylineDisplayLine>,
            assetCache: Sapphire.AssetCache,
            options: Sapphire.PaylineDisplayShowOptions,
            onComplete?: Function
        ): void {
            const animatedSymbols = this._data.animatedSymbols;
            let symbolAnimationsCompleted = 0;
            let reversedPayline = payline.slice().reverse();

            this.addChild(this._sprite2Mask);

            reversedPayline.forEach(({ x, y, symbol, duration, replaceWith }) => {
                var animatedSymbolIndex = animatedSymbols.indexOf(symbol);

                if (replaceWith && replaceWith.positions.length > 0) {
                    replaceWith.positions.forEach((position) => {
                        if (position.x === x && position.y === y) {
                            symbol = replaceWith.symbolFrame;
                            animatedSymbolIndex = animatedSymbols.indexOf(replaceWith.symbolFrame)
                        }
                    });
                }

                let sprite;
                if (animatedSymbolIndex > -1) {
                    sprite = new Sapphire.AnimatedSprite();
                    sprite.construct(this._data.animations[animatedSymbolIndex], assetCache);
                    if (duration) sprite.animationSpeed = (1 / sprite.totalFrames) * (sprite.totalFrames / duration);
                } else {
                    sprite = new PIXI.Sprite(assetCache.getTexture('BaseGame', 'symbols', symbol));
                }

                sprite.pivot = new PIXI.Point(sprite.width / 2, sprite.height / 2);
                sprite.x = (this._data.stepX / 2) + (this._data.stepX * x);
                sprite.y = (this._data.stepY / 2) + (this._data.stepY * y);

                if (sprite instanceof Sapphire.AnimatedSprite) {
                    if (this._data.animations[animatedSymbolIndex].offset) {
                        sprite.x += this._data.animations[animatedSymbolIndex].offset[0];
                        sprite.y += this._data.animations[animatedSymbolIndex].offset[1];
                    }
                }


                if (sprite instanceof Sapphire.AnimatedSprite) {
                    this.addChild(sprite);
                    sprite.setOnComplete(() => {
                        if (++symbolAnimationsCompleted >= payline.length && onComplete) {
                            onComplete();
                            symbolAnimationsCompleted = 0;
                        }
                    });
                    if (this._data.animations[animatedSymbolIndex].delay){
                        TweenMax.delayedCall(this._data.animations[animatedSymbolIndex].delay,() => {
                            sprite.play();
                        })
                    }else{
                        sprite.play();
                    }
                } else {
                    var sprite2 = new PIXI.Sprite(assetCache.getTexture('BaseGame', 'symbols', 'glow.png'));
                    sprite2.pivot = new PIXI.Point(sprite2.width / 2, sprite2.height / 2);
                    sprite2.x = (this._data.stepX / 2) + (this._data.stepX * x);
                    sprite2.y = (this._data.stepY / 2) + (this._data.stepY * y);
                    sprite2.scale.x = 0.8;
                    sprite2.scale.y = 0.8;
                    sprite2.mask = this._sprite2Mask;
                    this.addChild(sprite2);
                    this.addChild(sprite);
                    duration = duration || 1.5;
                }
            });
        }
    }
}
